export default {"src":"/_next/static/media/car_traffic_1.8a9d0fae.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};